/* eslint-disable no-restricted-globals */
import isEmpty from 'is-empty';

const validateInput = (data) => {
  const errors = {};
  if (data.amount === '' || !data.amount || data.amount.trim().length === 0) {
    errors.amount = 'This field is required.';
  }
  if (isNaN(data.amount)) {
    errors.amount = 'Invalid input.';
  }
  if (data.fundingSource === '' || !data.fundingSource || data.fundingSource.trim().length === 0) {
    errors.fundingSource = 'This field is required.';
  }
  if (data.tenorInDays === '' || !data.tenorInDays || data.tenorInDays.trim().length === 0) {
    errors.tenorInDays = 'This field is required.';
  }
  if (data.tenorInDays !== '91' && data.tenorInDays !== '182' && data.tenorInDays !== '364') {
    errors.tenorInDays = 'Tenor must be either 91, 182 or 364 days';
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
};

export default validateInput;
